import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";
import { PrefToggles } from "./PrefToggles";
import { useT } from "../lib/prefs";

export const Header = () => {
  const t = useT();
  return (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 inset-x-0 z-50 bg-[#0B0518]/70 backdrop-blur-xl border-b border-violet-500/15"
    data-testid="site-header"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-2">
      <Logo />
      <div className="flex items-center gap-2 sm:gap-4">
        <span className="hidden lg:flex items-center gap-2 font-mono text-xs text-violet-200">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" /> {t.registrationOpen}
        </span>
        <PrefToggles />
        <button
          data-testid="header-book-btn"
          onClick={() => scrollToId("booking")}
          className="btn-neon text-xs sm:text-sm px-3.5 sm:px-5 py-2.5 rounded-full font-semibold whitespace-nowrap"
        >
          {t.bookSeat}
        </button>
      </div>
    </div>
  </motion.header>
  );
};
